import request from '@/utils/request'
import qs from 'qs'

export function queryPhrases(data) {
    return request({
        url: '/api-admin/phrase/queryPhrases',
        method: 'get',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        params: data
    })
}

export function updatePhrase(data) {
    return request({
        url: '/api-admin/phrase/updatePhrase',
        method: 'post',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: qs.stringify(data)
    })
}

export function deletePhrase(id) {
    return request({
        url: '/api-admin/phrase/delete',
        method: 'post',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        params: { id }
    })
}